import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 4.636A2.636 2.636 0 014.636 2h14.728A2.636 2.636 0 0122 4.636v14.728A2.636 2.636 0 0119.364 22H4.636A2.636 2.636 0 012 19.364V4.636zM4.636 4A.636.636 0 004 4.636v14.728c0 .351.285.636.636.636h14.728a.636.636 0 00.636-.636V4.636A.636.636 0 0019.364 4H4.636zm9.228 4.318a1 1 0 011-1h2.863a1 1 0 011 1v2.864a1 1 0 11-2 0v-.167l-3.156 3.607a1 1 0 01-1.46.049L10.2 12.76l-3.22 3.22a1 1 0 11-1.414-1.414l3.927-3.928a1 1 0 011.414 0l1.863 1.863 2.784-3.183h-.69a1 1 0 01-1-1z",
      fill: "#292933"
    }
  )
), t = a;
export {
  t as default
};
